import { OfficeDialogMessageType } from "@/common/enums";
import { deleteSelectResourceDialog, updateAllResourcesDataInSelectedChangeRsOutlook } from "@/redux/slices/resources/ResourceSlice";
import { IFetchResourceRequest, IMessageFromDialog, IResourceService, ResourceInfo, ResourceService } from "@/services";
import { Dispatch } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import ResourceSelected from ".";

const mapDispatchToProps = (dispatch: Dispatch<any>, ownProps: { messageToParent?: (messageObject: IMessageFromDialog) => void }) => {
  return {
    getResourcesDataForSelected: async (
      request: IFetchResourceRequest
    ): Promise<void> => {
      const resourceServiceImpl: IResourceService = new ResourceService();
      const response = await resourceServiceImpl.fetchResourcesByEmails(
        request
      );
      if (!response.error) {
        dispatch(updateAllResourcesDataInSelectedChangeRsOutlook(response.data));
      }
    },
    deleteSelectResource: (resource: ResourceInfo) => {
      if(ownProps?.messageToParent) {
        ownProps?.messageToParent({MessageType: OfficeDialogMessageType.DeResourceSelected, data: resource?.toJson()})
      }
      dispatch(deleteSelectResourceDialog(resource));
    },
  }
};

export default connect(null, mapDispatchToProps)(ResourceSelected);
